<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import ContractUpdateForm from '@/modules/contract/components/ContractUpdateForm.vue'
</script>

<template>
<dashboard-layout current-route="contracts/list" page-title="Thêm hợp đồng mới">
  <panel class="md:w-full">
    <ContractUpdateForm :listing-id="null" :contract-id="null" action="create"/>
  </panel>
</dashboard-layout>
</template>

<style scoped>

</style>
